import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import IconTitle from '@/components/IconTitle.vue';
import ProductCard from '@/components/ProductCard.vue';
import { Product } from '@/models/product_model';
import { useCartStore } from '@/store/cart_store';
import { Icons } from '@/font-awesome';
import ShimmerGFX from '@/components/ShimmerGFX.vue';
import { DOMUtils } from '@/infra/utils/dom.utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsSection',
  props: {
    products: { type: Array, required: true },
    isLoaded: { type: Boolean, required: true }
  },
  emits: ["on-reach-bottom"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const offersScrollTop = ref<HTMLElement>();
const offersBottom = ref<HTMLElement>();

__expose({
  scrollToTop: () => {
    if (offersScrollTop.value) {
      offersScrollTop.value?.scrollIntoView({ behavior: 'smooth' });
    }
  }
});

const emits = __emit;

const showedUp = ref(false);
window.addEventListener('scroll', () => {
  const previousShowedUp = showedUp.value;
  showedUp.value = DOMUtils.isInViewport(offersBottom.value!);
  if (showedUp.value && !previousShowedUp) emits('on-reach-bottom');
});

const cartStore = useCartStore();


const __returned__ = { offersScrollTop, offersBottom, emits, showedUp, cartStore, IconTitle, ProductCard, get Icons() { return Icons }, ShimmerGFX }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})